/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import axios from "../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { QRCodeSVG } from "qrcode.react";
import { logo_image, pdf_bg, glowing_arrow } from "../../assets/images";
import { Button } from "react-bootstrap";
import { BiSolidPrinter } from "react-icons/bi";

export default function TermsAndCondition() {
  const { certificateId, clientId } = useParams();
  const [loading, setLoading] = useState(false);
  const [certificate_details, setCertificateDetails] = useState(null);
  const [corporateClientLogo, setCorporateClientLogo] = useState("");
  const [supportEmail, setSupportEmail] = useState("");

  useEffect(() => {
    fetchTermsAndCondition();
  }, [certificateId, clientId]);

  const fetchTermsAndCondition = () => {
    setLoading(true);
    axios
      .get(`/get-terms-condition-certificate/${certificateId}/${clientId}`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const { certificateTerms, corporateClientLogo, supportEmail } =
            res.data.data;
          setCertificateDetails(certificateTerms);
          setCorporateClientLogo(corporateClientLogo);
          setSupportEmail(supportEmail);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const printDocument = () => {
    let printContents = document.getElementById("print_content").innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    window.close();
    window.location.reload();
  };

  return (
    <LoadingOverlay spinner active={loading} text="Loading...">
      <div
        className="row"
        style={{ width: "23cm", padding: "0", margin: ".5cm auto 0" }}
      >
        <div className="col-md-12">
          <h1 className="float-left text-center">Terms and Conditions</h1>

          <Button
            variant="primary"
            className="float-right"
            type="button"
            onClick={() => {
              printDocument();
            }}
          >
            <BiSolidPrinter />
          </Button>
        </div>
      </div>

      {certificate_details && (
        <div
          className="pdf_inner_inner_box1"
          id="print_content"
          style={{ width: "23cm", margin: "0 auto" }}
        >
          <div className="pdf_boxi1">
            <div className="create_pdfff1">
              <table
                className="pdf_content"
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style={{
                  backgroundColor: "#fff",
                  color: "#000000",
                  width: "100%",
                  margin: "0",
                }}
              >
                <tr>
                  <td>
                    <div className="pdf_banner">
                      <img
                        src={certificate_details.banner}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "340px",
                          objectFit: "cover",
                        }}
                        alt="Travel Certificate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      background: `#fff url(${pdf_bg}) center center / cover no-repeat`,
                      paddingTop: "30px",
                    }}
                  >
                    <table
                      align="center"
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      style={{
                        width: "100%",
                        color: "#000000",
                      }}
                    >
                      <tr>
                        <td
                          lg="3"
                          md="4"
                          sm="12"
                          valign="top"
                          className="padding_top30px"
                          style={{ padding: "8px 15px", width: "30%" }}
                        >
                          <div
                            className="pdf_price_img"
                            tyle={{ marginBottom: "20px" }}
                          >
                            <img
                              src={certificate_details.pricetag}
                              className="img-fluid"
                              style={{ maxWidth: "100%" }}
                              alt="Price Tag"
                            />
                          </div>
                          <div
                            className="scan_code code_scan"
                            style={{ marginBottom: "20px" }}
                          >
                            <QRCodeSVG
                              className="img-fluid"
                              style={{ maxWidth: "100%" }}
                              value={`${certificate_details.qr_code}`}
                            />
                          </div>

                          <div
                            className="pdf_logo_img logo_pdf"
                            style={{ marginTop: "280px" }}
                          >
                            <img
                              src={corporateClientLogo || logo_image}
                              className="img-fluid"
                              style={{
                                maxWidth: "200px",
                                maxHeight: "200px",
                                objectFit: "contain",
                              }}
                              alt="Logo"
                            />
                          </div>
                        </td>
                        <td
                          lg="9"
                          md="8"
                          sm="12"
                          valign="top"
                          style={{
                            padding: "8px 15px",
                            paddingRight: "20px",
                            width: "70%",
                          }}
                        >
                          <div className="certificate_terms inner_termmmms">
                            <h2>Terms of the Certificate</h2>
                            <div
                              className="text-justify"
                              dangerouslySetInnerHTML={{
                                __html:
                                  certificate_details.certificate_description,
                              }}
                            />

                            <div
                              style={{
                                background: `url(${glowing_arrow}) 65% center  / contain no-repeat`,
                              }}
                            >
                              <h3>GET YOUR CERTIFICATE TODAY!</h3>
                              <div className="go_online online_go">
                                <p>Go Online: https://redeem.viptravelreward.com</p>

                                <p>
                                  Enter Referral Code:{" "}
                                  {certificate_details.referral_code}
                                </p>
                                <p>
                                  Certificate Code:
                                  {certificate_details.certificate_code}
                                </p>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "8px 15px" }}>
                          <div
                            className="foot_cont"
                            style={{ textAlign: "center" }}
                          >
                            <p>
                              If you have general questions about your
                              certificate please email {supportEmail} Monday to
                              Friday from 9 AM to 5 PM Central Time.
                            </p>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      )}
    </LoadingOverlay>
  );
}
